import { Email, Phone } from '@mui/icons-material'
import { Box, Stack, Typography, Link, styled, useTheme } from '@mui/material'
import Socials from '../components/Socials'
import { useCompanySpaces } from '../queries/useCompanyQueries'

const FooterStyled = styled(Box)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.common.white,
  borderTop: `2px solid ${
    theme.palette.mode === 'dark' ? theme.palette.divider : theme.palette.primary.main
  }`,
  width: '100%',
  height: '70px',
  display: 'flex',
  alignItems: 'center'
}))

const FooterContent = styled(Box)(({ theme }) => ({
  width: '100%',
  margin: '0 auto',
  padding: '0 24px',
  [theme.breakpoints.up('lg')]: {
    padding: '0 48px'
  }
}))

const Footer = () => {
  const theme = useTheme()
  const { data: companyData } = useCompanySpaces()

  const footerData = companyData?.body?.content[0]
    ? {
        email: companyData.body.content[0].mail,
        phone: companyData.body.content[0].phone,
        description: companyData.body.content[0].description,
        socials: companyData.body.content[0].listSocialNetwork?.reduce((acc: any, item: any) => {
          acc[item.name] = item.url
          return acc
        }, {}),
        logofooter: '/images/favicon.ico'
      }
    : {
        email: '',
        phone: '',
        description: '',
        socials: {},
        logofooter: '/images/favicon.ico'
      }

  return (
    <FooterStyled>
      <FooterContent>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ height: '100%' }}
        >
          {/* BitCode Enterprise - Lado izquierdo */}
          <Stack direction="row" spacing={2} alignItems="center">
            <img src={footerData.logofooter} alt="logo" style={{ width: '40px', height: 'auto' }} />
            <Stack spacing={0}>
              <Typography
                variant="caption"
                color={theme.palette.mode === 'dark' ? 'text.primary' : 'text.secondary'}
              >
                © {new Date().getFullYear()} SpaceManager
              </Typography>
              <Typography
                variant="caption"
                color={theme.palette.mode === 'dark' ? 'text.primary' : 'text.secondary'}
              >
                Desarrollado por{' '}
                <Link
                  href="https://bitcode-enterprise.com"
                  target="_blank"
                  rel="noreferrer"
                  underline="none"
                  color="primary"
                  sx={{ fontWeight: 500 }}
                >
                  Bitcode Enterprise
                </Link>
              </Typography>
            </Stack>
          </Stack>

          {/* Información del Cliente - Lado derecho */}
          <Stack direction="row" spacing={3} alignItems="center">
            <Typography
              variant="body2"
              color={theme.palette.mode === 'dark' ? 'text.primary' : 'text.primary'}
              fontWeight={800}
            >
              {footerData.description}
            </Typography>

            {footerData.phone && (
              <Stack direction="row" spacing={1} alignItems="center">
                <Phone color="primary" fontSize="small" />
                <Typography
                  variant="body2"
                  color={theme.palette.mode === 'dark' ? 'text.primary' : 'text.secondary'}
                >
                  {footerData.phone}
                </Typography>
              </Stack>
            )}

            {footerData.email && (
              <Stack direction="row" spacing={1} alignItems="center">
                <Email color="primary" fontSize="small" />
                <Link
                  href={`mailto:${footerData.email}`}
                  variant="body2"
                  underline="hover"
                  color={theme.palette.mode === 'dark' ? 'text.primary' : 'text.secondary'}
                >
                  {footerData.email}
                </Link>
              </Stack>
            )}

            <Socials socials={footerData.socials} />
          </Stack>
        </Stack>
      </FooterContent>
    </FooterStyled>
  )
}

export default Footer
